<div class="formulario-wrapper">
  <form [formGroup]="form" class="formulario-form">
    @for (secao of obterSecoes(); track secao.titulo) {
      <p-card class="formulario-card">
        <ng-template pTemplate="title">{{ secao.titulo }}</ng-template>
        <ng-template pTemplate="subtitle">
          @if (secao.descricao) {
            {{ secao.descricao }}
          }
        </ng-template>

        @if (!usarConteudoCustomizado || conteudoAposCampos) {
          <div class="grid formulario-grid">
            @for (campo of secao.campos; track campo.chave) {
              @if (campo.visivel !== false) {
                <div class="formulario-campo" [ngClass]="obterClasseCampo(campo)">
                  <label [for]="campo.chave">
                    {{ campo.rotulo }}
                    @if (isCampoObrigatorio(campo)) {
                      <span class="campo-obrigatorio">*</span>
                    }
                  </label>

                @if (campo.tipo === 'texto' || campo.tipo === 'email' || campo.tipo === 'senha') {
                  @if (campo.mascara) {
                    <p-inputMask
                      class="w-full"
                      [fluid]="true"
                      [id]="campo.chave"
                      [mask]="campo.mascara"
                      [placeholder]="campo.placeholder"
                      [formControlName]="campo.chave"
                    ></p-inputMask>
                  } @else if (campo.mascaraTipo) {
                    <input
                      class="w-full"
                      pInputText
                      [fluid]="true"
                      [id]="campo.chave"
                      [placeholder]="campo.placeholder"
                      [formControlName]="campo.chave"
                      [appMascara]="campo.mascaraTipo"
                    />
                  } @else {
                    <input
                      class="w-full"
                      pInputText
                      [fluid]="true"
                      [type]="campo.tipo === 'email' ? 'email' : campo.tipo === 'senha' ? 'password' : 'text'"
                      [id]="campo.chave"
                      [placeholder]="campo.placeholder"
                      [readonly]="campo.readonly"
                      [disabled]="campo.desabilitado ?? false"
                      [formControlName]="campo.chave"
                    />
                  }
                }

                @if (campo.tipo === 'cpf') {
                  <input
                    class="w-full"
                    [fluid]="true"
                    pInputText
                    [id]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [readonly]="campo.readonly"
                    [disabled]="campo.desabilitado ?? false"
                    [formControlName]="campo.chave"
                    appMascara="CPF"
                  />
                }

                @if (campo.tipo === 'cnpj') {
                  <input
                    class="w-full"
                    pInputText
                    [fluid]="true"
                    [id]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [readonly]="campo.readonly"
                    [disabled]="campo.desabilitado ?? false"
                    [formControlName]="campo.chave"
                    appMascara="CNPJ"
                  />
                }

                @if (campo.tipo === 'telefone') {
                  <input
                    class="w-full"
                    pInputText
                    [fluid]="true"
                    [id]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [readonly]="campo.readonly"
                    [disabled]="campo.desabilitado ?? false"
                    [formControlName]="campo.chave"
                    appMascara="TELEFONE"
                  />
                }

                @if (campo.tipo === 'cep') {
                  <input
                    class="w-full"
                    pInputText
                    [fluid]="true"
                    [id]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [readonly]="campo.readonly"
                    [disabled]="campo.desabilitado ?? false"
                    [formControlName]="campo.chave"
                    appMascara="CEP"
                  />
                }

                @if (campo.tipo === 'textarea' || campo.tipo === 'observacoes') {
                  <textarea
                    class="w-full"
                    pInputTextarea
                    [fluid]="true"
                    [id]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [autoResize]="true"
                    [readonly]="campo.readonly"
                    [disabled]="campo.desabilitado ?? false"
                    [formControlName]="campo.chave"
                  ></textarea>
                }

                @if (campo.tipo === 'dropdown' || campo.tipo === 'status') {
                  <p-select
                    class="w-full"
                    [fluid]="true"
                    appendTo="body"
                    [inputId]="campo.chave"
                    [options]="campo.opcoes"
                    [virtualScroll]="usarLookupLazy(campo)"
                    [virtualScrollItemSize]="30"
                    [lazy]="usarLookupLazy(campo)"
                    (onLazyLoad)="carregarLookupLazy(campo, $event)"
                    [filter]="campo.filtro ?? true"
                    [optionLabel]="campo.optionLabel ?? 'label'"
                    [optionValue]="campo.optionValue ?? 'value'"
                    [optionDisabled]="campo.optionDisabled ?? 'disabled'"
                    [placeholder]="campo.placeholder"
                    [showClear]="campo.permiteLimpar ?? true"
                    [disabled]="(campo.desabilitado ?? false) || (campo.readonly ?? false)"
                    [formControlName]="campo.chave"
                    (onChange)="aoSelecionarOpcao(campo, $event.value)"
                  ></p-select>
                }

                @if (campo.tipo === 'multiselecao') {
                  <p-multiSelect
                    class="w-full"
                    [fluid]="true"
                    [filter]="true"
                    [inputId]="campo.chave"
                    [options]="campo.opcoes"
                    [optionLabel]="campo.optionLabel ?? 'label'"
                    [optionValue]="campo.optionValue ?? 'value'"
                    [optionDisabled]="campo.optionDisabled ?? 'disabled'"
                    [placeholder]="campo.placeholder"
                    selectedItemsLabel="{0} itens selecionados"
                    [display]="'chip'"
                    [disabled]="(campo.desabilitado ?? false) || (campo.readonly ?? false)"
                    [formControlName]="campo.chave"
                  ></p-multiSelect>
                }

                @if (campo.tipo === 'autocomplete') {
                  <p-autoComplete
                    class="w-full"
                    [fluid]="true"
                    [inputId]="campo.chave"
                    [suggestions]="obterSugestoes(campo)"
                    (completeMethod)="buscarSugestoes(campo, $event.query)"
                    (onSelect)="aoSelecionarAutocomplete(campo, $event.value)"
                    (onClear)="aoLimparAutocomplete(campo)"
                    field="label"
                    [placeholder]="campo.placeholder"
                    [formControlName]="campo.chave"
                    [forceSelection]="false"
                  ></p-autoComplete>
                }

                @if (campo.tipo === 'calendario') {
                  <p-datepicker
                    class="w-full"
                    [fluid]="true"
                    [inputId]="campo.chave"
                    [formControlName]="campo.chave"
                    [dateFormat]="obterFormatoData(campo)"
                    [view]="obterVisaoData(campo)"
                    [placeholder]="campo.placeholder"
                    [showIcon]="true"
                    appendTo="body"
                    [readonlyInput]="campo.readonly ?? false"
                    [disabled]="campo.desabilitado ?? false"
                  ></p-datepicker>
                }

                @if (campo.tipo === 'intervalo-datas') {
                  <p-datepicker
                    class="w-full"
                    [fluid]="true"
                    [inputId]="campo.chave"
                    selectionMode="range"
                    [formControlName]="campo.chave"
                    dateFormat="dd/mm/yy"
                    [placeholder]="campo.placeholder"
                    [showIcon]="true"
                    appendTo="body"
                    [readonlyInput]="campo.readonly ?? false"
                    [disabled]="campo.desabilitado ?? false"
                  ></p-datepicker>
                }

                @if (campo.tipo === 'numero') {
                  <p-inputNumber
                    class="w-full"
                    [fluid]="true"
                    [inputId]="campo.chave"
                    [formControlName]="campo.chave"
                    [placeholder]="campo.placeholder"
                    [min]="campo.minimo"
                    [max]="campo.maximo"
                    [minFractionDigits]="campo.minFractionDigits"
                    [maxFractionDigits]="campo.maxFractionDigits"
                    [prefix]="campo.prefixo"
                    [suffix]="campo.sufixo"
                    [readonly]="campo.readonly ?? false"
                    [disabled]="campo.desabilitado ?? false"
                    mode="decimal"
                  ></p-inputNumber>
                }

                @if (campo.tipo === 'moeda') {
                  <p-inputNumber
                    class="w-full"
                    [fluid]="true"
                    [inputId]="campo.chave"
                    [formControlName]="campo.chave"
                    [placeholder]="campo.placeholder"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    [readonly]="campo.readonly ?? false"
                    [disabled]="campo.desabilitado ?? false"
                  ></p-inputNumber>
                }

                @if (campo.tipo === 'switch') {
                  <div class="campo-switch">
                    <p-toggleswitch
                      [inputId]="campo.chave"
                      [formControlName]="campo.chave"
                    ></p-toggleswitch>
                  </div>
                }

                @if (campo.tipo === 'checkbox') {
                  <div class="campo-check">
                    <p-checkbox
                      [inputId]="campo.chave"
                      [binary]="true"
                      [formControlName]="campo.chave"
                    ></p-checkbox>
                    <span>{{ campo.placeholder }}</span>
                  </div>
                }

                <small
                  class="mensagem-validacao"
                  [class.mensagem-validacao--oculta]="
                    !(form.get(campo.chave)?.invalid && form.get(campo.chave)?.touched)
                  "
                >
                  {{
                    form.get(campo.chave)?.invalid && form.get(campo.chave)?.touched
                      ? obterMensagemErro(campo)
                      : ' '
                  }}
                </small>
                </div>
              }
            }
          </div>
        }
        @if (usarConteudoCustomizado || conteudoAposCampos) {
          <div class="formulario-custom">
            <ng-content select="[formulario-conteudo]"></ng-content>
          </div>
        }
      </p-card>
    }
  </form>

  @if (mostrarAcoes) {
    <div class="formulario-acoes">
      <button pButton type="button" class="p-button-outlined" label="Voltar" (click)="aoVoltar.emit()"></button>
      <button pButton type="button" class="p-button-secondary" label="Cancelar" (click)="aoCancelar.emit()"></button>
      <button pButton type="button" label="Salvar" [disabled]="isVisualizacao() || processando" (click)="salvar()"></button>
      @for (acao of acoesPersonalizadas; track acao.rotulo) {
        <button pButton type="button" class="p-button-outlined" [class]="acao.classe" [icon]="acao.icone"
          [label]="acao.rotulo" [disabled]="acao.desabilitado" (click)="acao.aoClicar()"></button>
      }
    </div>
  }
</div>
